import {BaseSpringServiceCB} from '@aiknow-srl/aik-ngx-http';
import {UserOPEEnum} from "./UserOPEEnum";
import {AWSConnectionOptions} from "../../models/aws/AWSConnectionOptions";
import {ApiConfig} from "../../models/external-application/ApiConfig";

/**
 * EnumDTO Inner Class
 */
class EnumDTO {
  value!: string;
  label!: string;
}

/**
 * DataTypeDTO Inner Class
 */
class DataTypeDTO {
  value!: string;
  label!: string;
  showAsHex!: boolean;
  isNumeric!: boolean;
  supportsBitPosition!: boolean;
  supportsDivisor!: boolean;
  supportsUnit!: boolean;
  supportsDecimals!: boolean;
}

/**
 * TransportFunctionDTO Inner Class
 */
class TransportFunctionDTO {
  value!: string;
  label!: string;
  isWriteFunction!: boolean;
  typeBlackList?: string[];
}


/**
 * I Inner Class
 */
class I {
  channel!: string;
}

/**
 * O Inner Class
 */
class O {

  /**
   * Application ID
   */
  appId!: string;
  /**
   * Environment type
   */
  envId!: string;
  /**
   * Versione corrente dell'applicazione
   */
  appVersion!: string;
  /**
   * Environment Label type
   */
  envIdLabel!: string;
  /**
   * Logged User
   */
  user!: UserDTO;
  /**
   * Languages list
   */
  localeList!: LocaleDTO[];
  /**
   * Roles list
   */
  roles!: string[];
  /**
   * Modbus data type values
   */
  modbusDataTypeValues!: DataTypeDTO[];
  /**
   * S7 data type values
   */
  s7DataTypeValues!: DataTypeDTO[];
  /**
   * Modbus function values
   */
  modbusFunctionValues!: TransportFunctionDTO[];
  /**
   * S7 function values
   */
  s7FunctionValues!: TransportFunctionDTO[];
  /**
   * Byte order values
   */
  byteOrderValues!: EnumDTO[];
  /**
   * Default byte order value
   */
  defaultByteOrderValue!: EnumDTO;
  /**
   * Modbus protocols values
   */
  protocolTypeValues!: EnumDTO[];
  /**
   * OS types
   */
  osTypesValues!: EnumDTO[];
  /**
   * Opzioni per la scrittura di metriche
   */
  writeOnEdgeOriginTypeValues!: EnumDTO[];
  /**
   * Opzioni per l'utilizzo dei servizi di AWS
   */
  awsOptions!: AWSConnectionOptions;

  /**
   * Default config delle api external application
   */
  eaApiConfigMapDefault!: Record<string, ApiConfig>

  /**
   * Numero massimo di punti telemetrici che possono essere richiesti al BE
   */
  maxTelemetryPointListSize!: number;

}

class UserDTO {
  id!: number;
  /**
   * Username of logged partitionUser
   */
  username!: string;
  email!: string;
  /**
   * First Name of logged partitionUser
   */
  firstname!: string;
  /**
   * Last Name of logged partitionUser
   */
  lastname!: string;
  /**
   * Language of logged partitionUser
   */
  language?: string;
  /**
   * Roles of logged partitionUser
   */
  roles?: string[];
  /**
   * List of menuItems items
   */
  menuItems!: MenuGroupDTO[];

  partition!: PartitionDTO;

  pushNotificationInfo!: PushNotificationInfoDTO;
}

class PushNotificationInfoDTO {
  brokerUsername!: string;
  brokerPassword!: string;
  notificationToken!: string;
}

class PartitionDTO {
  /**
   * Partition id
   */
  id!: number;
  /**
   * Id of the optional partition parent
   */
  parentId?: number;
  /**
   * Partition name
   */
  name!: string;
  /**
   * Is partition active
   */
  active!: boolean;
}

class MenuDTO {
  /**
   * id
   */
  id!: string;
  /**
   * Name of the component
   */
  path!: string;
  /**
   * icon
   */
  icon?: string;
}

class LocaleDTO {
  /**
   * Language locale
   */
  locale!: string;
  /**
   * Country flag
   */
  countryFlag?: string;
}

class RoleDTO {
  /**
   * Role name
   */
  name!: string;
  /**
   * Role priority
   */
  priority!: number;
}


class MenuGroupDTO {
  /**
   * id
   */
  id!: number;
  /**
   * Name of the menu group
   */
  name!: string;
  /**
   * Enabled roles
   * Empty -> all roles
   */
  roles!: string[];
  /**
   * OrderIndex
   */
  orderIndex!: number;
  /**
   * icon
   */
  voices!: MenuVoiceDTO[];
}

class MenuVoiceDTO {
  /**
   * id
   */
  id!: number;
  /**
   * Name of the menu group
   */
  name!: string;
  /**
   * OrderIndex
   */
  orderIndex!: number;
  /**
   * icon
   */
  functions!: MenuVoiceFunctionDTO[];
}

class MenuVoiceFunctionDTO {
  /**
   * id
   */
  id!: number;
  /**
   * Name of the menu group
   */
  name!: string;
}


/**
 * GetTransportItemDetailCB class
 */
export class PostLoginCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(UserOPEEnum.PostLogin);
    this.i = new I();
    this.o = new O();

  }

}
